import { useTheme } from "@mui/material";

function IntroUpArrow() {
  const theme = useTheme();
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="115" height="85" viewBox="0 0 115 85" fill="none" className="IntroUpArrow">
      <g clipPath="url(#clip0_310_2003)">
        <path
          d="M82.4098 78.6801C80.0937 78.1312 77.8183 77.4228 75.5998 76.5601C58.1798 69.1401 41.5999 55.7101 35.9399 37.3201C33.5199 29.8101 32.9399 21.9001 32.7299 14.0201C41.1099 20.4701 53.8799 30.2701 53.8799 30.2701C54.6052 30.8496 55.5311 31.1172 56.4538 31.014C57.3765 30.9109 58.2204 30.4454 58.7999 29.72C59.3794 28.9947 59.647 28.0689 59.5438 27.1462C59.4407 26.2235 58.9752 25.3795 58.2499 24.8L30.7399 2.05005L28.2599 0.0500488C25.0099 2.46005 21.6999 5.16009 18.6699 7.84009C13.2399 12.6701 7.66986 18.0401 2.60986 23.2601L1.05987 24.8701L0.289848 25.6801C0.179848 25.8401 -0.0301203 25.8801 0.00987966 26.2101C0.190878 26.8765 0.47422 27.5107 0.849845 28.0901C1.35279 28.5654 1.92625 28.9601 2.54986 29.2601C2.86986 29.3601 2.94986 29.1601 3.11986 29.0801L4.04986 28.4601C9.74986 24.6801 15.4699 20.73 20.9799 16.54C19.8999 31.13 25.8198 46.1601 34.8498 57.4301C44.8498 69.7101 59.0398 77.5601 73.9498 82.1501C87.0498 85.1501 104.95 85.9501 114.62 75.0101C105.48 82.3701 93.0598 81.1901 82.4098 78.6801Z"
          fill={theme.palette.primary.main}
        />
      </g>
      <defs>
        <clipPath id="clip0_310_2003">
          <rect width="114.61" height="84.05" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default IntroUpArrow;
